export function deletar(fetch, id) {
  return fetch().delete("/Grupo/" + id);
}

export function getAll(fetch) {
  return fetch().get("/Grupo");
}

export function getDetalhe(fetch, id) {
  return fetch().get("/Grupo/" + id);
}

export function put(fetch, loja) {
  return fetch().put("/Grupo", loja);
}
export function post(fetch, loja) {
  return fetch().post("/Grupo", loja);
}
